import { Label } from 'src/components/ui/label';
import { Switch } from 'src/components/ui/switch';
import type { ConfigRendererProps } from './types';

/**
 * Config renderer for the fetch_purchase_order_from_famous step
 * Allows configuring whether to cancel the workflow if the purchase order is not found
 */
export function FetchPurchaseOrderFromFamousConfigRenderer({
  config,
  onConfigChange,
}: ConfigRendererProps) {
  const cancelIfNotFound = Boolean(config.cancelIfNotFound);

  const handleCancelIfNotFoundToggle = (checked: boolean) => {
    onConfigChange({
      ...config,
      cancelIfNotFound: checked,
    });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2 rounded-md border p-3">
        <div className="flex items-center justify-between gap-3">
          <div>
            <Label htmlFor="cancelIfNotFound" className="text-sm font-medium">
              Cancel if not found
            </Label>
            <p className="text-xs text-muted-foreground mt-1">
              Cancel the workflow if the purchase order is not found in Famous
              Software.
            </p>
          </div>
          <Switch
            id="cancelIfNotFound"
            checked={cancelIfNotFound}
            onCheckedChange={handleCancelIfNotFoundToggle}
            aria-label="Cancel if purchase order not found"
          />
        </div>
        <p className="text-[11px] text-muted-foreground">
          When enabled, the workflow will be cancelled if the specified purchase
          order number does not exist in Famous. When disabled, the step will
          fail but the workflow may continue depending on error handling
          configuration.
        </p>
      </div>
    </div>
  );
}
